export const FETCH_USERS_DOSSIERS_REQUEST = 'FETCH_DOSSIERS_REQUEST';
export const FETCH_USERS_DOSSIERS_SUCCESS = 'FETCH_DOSSIERS_SUCCESS';
export const FETCH_USERS_DOSSIERS_FAILURE = 'FETCH_DOSSIERS_FAILURE';

export const UPDATE_USERCREATION_REQUEST = 'UPDATE_USERCREATION_REQUEST';
export const UPDATE_USERCREATION_SUCCESS = 'UPDATE_USERCREATION_SUCCESS';
export const UPDATE_USERCREATION_FAILURE = 'UPDATE_USERCREATION_FAILURE';